import React, { Component, Fragment } from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import poRequestHandler from '../../../api/pickupOrderRemote';

import TrkDropoffOrder from './TrkDropoffOrder';
import DockerOverloadModalContainer from '../../dockOverloadModal/DockerOverloadModalContainer';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderModel from '../../../models/PickupOrder';

import moment, { Moment } from 'moment';

import { PO_SCHEMA } from '../../../utils/pickupOrder';

interface MatchParams {
  do: string;
  key: string;
};

interface TrkDropoffOrderProps extends RouteComponentProps<MatchParams>{
  receiveError: Function;
  receiveSuccess: Function;
};

interface TrkDropoffOrderState {
  dropOffOrder: PickupOrderModel;
  openDockOverloadModal: boolean;
  sealNumber: string,
  checked: string;
  error: boolean;
};

class TrkDropoffOrderContainer extends Component<TrkDropoffOrderProps, TrkDropoffOrderState> {

  state = {
    dropOffOrder: PO_SCHEMA,
    openDockOverloadModal: false,
    sealNumber: '',
    checked: '',
    error: false
  }

  componentDidMount() {

    const params: MatchParams = this.props.match.params;

    poRequestHandler.getPickupOrder(params.do, params.key).then((resp: ApiResponse<PickupOrderModel>) => {

      const dO: PickupOrderModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (dO) {
        // keep the initial values to '' instead of nulls because react throws a warning for uncontrolled components 
        dO.additional_info = dO.additional_info || '';
        dO.trucker_info = dO.trucker_info || '';
        dO.driver_name = dO.driver_name || '';
        dO.driver_id = dO.driver_id || '';
        dO.driver_id_type = dO.driver_id_type || 'CDL';
        dO.driver_vehichle_registration = dO.driver_vehichle_registration || '';
        dO.rfs_number = dO.rfs_number || '';
        dO.allowed_ops = dO.allowed_ops || {
          update_date: true,
          update_awb_address: true,
          update_dispatch_driver_details: true,
          driver_checked_in: true,
          update_wh_locations: true,
          set_dock: true,
          update_exception_and_notes: true,
          update_customs_clearance: true,
        }


        this.setState({ dropOffOrder: dO });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleChange = (fieldName: string, event: any): void => {

    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    const value: string = event.target.value;

    switch (fieldName) {
      case 'truckerInformation': 
			currentDO.trucker_info = value; 
        break;
      case 'driverName':
				currentDO.driver_name = value;
        break;
      case 'driverId':
				currentDO.driver_id = value;
        break;
      case 'driverIdType':
        currentDO.driver_id_type = value;
        break;
      case 'driverVehichleRegistration':
				currentDO.driver_vehichle_registration = value;
        break;
      default: break;
    }

    this.setState({ dropOffOrder: currentDO });
  }

  handleSave = (): void => {

    const params: MatchParams = this.props.match.params;

    poRequestHandler.saveDriverInfo(this.state.dropOffOrder.number, params.key, this.state.dropOffOrder).then((resp: ApiResponse<boolean>) => {
      
      const dO: any = resp.result;
      if (dO) {
        this.props.receiveSuccess('The DO has been successfully updated!');
      }

      const error: ResponseError | undefined = resp.error;
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleCloseDockOverloadModal = (time: string): void => {

    if (time) {

      const setTime: string = time.replace('.','');
      const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
      
      currentDO.pickup_time = setTime;
      this.setState({ dropOffOrder: currentDO });
    };
    this.setState({ openDockOverloadModal: false });
  };

  handleSelectPickUpTime = (): void => {
    this.setState({ openDockOverloadModal: true });
  }

  handleChangeDropoffDate = (type: string, date: Moment): void => {

    const dO:  PickupOrderModel = { ...this.state.dropOffOrder };
    const currentDateStr = dO.pickup_date;
    const newDateToString: string = moment(date).format('YYYYMMDD');

    if (currentDateStr !== newDateToString) {

      dO.pickup_date = newDateToString;
      this.setState({ dropOffOrder: dO,  });
    }
  }

  setContainerState = (data: any): void => {   
    
    this.setState({dropOffOrder: data});
    
  };

  render() {
    return (
      <Fragment>
        <TrkDropoffOrder
          dropOffOrder={ this.state.dropOffOrder }
          secretKey={ this.props.match.params.key }
          handleChange={ this.handleChange }
          handleSave={ this.handleSave }
          handleSelectPickUpTime={ this.handleSelectPickUpTime }
          handleChangeDropoffDate={ this.handleChangeDropoffDate }
          setContainerState={ this.setContainerState }
          error={ this.state.error }
         />
        { this.state.openDockOverloadModal &&
          <DockerOverloadModalContainer 
            openDockOverloadModal={ this.state.openDockOverloadModal }
            handleCloseDockOverloadModal={ this.handleCloseDockOverloadModal }
            ghaID={ this.state.dropOffOrder.id_gha }
            type={ 'export' }
            forInfo={ false }
            date={ this.state.dropOffOrder.pickup_date }
            time={ this.state.dropOffOrder.pickup_time }
            secretKey={ this.props.match.params.key }
          />
        }
      </Fragment>
    );
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(TrkDropoffOrderContainer);
